module.exports = __webpack_public_path__ + "assets/img/VVIP.f25b93f9.png";